import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-aniPlay",
  "use": "icon-aniPlay-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-aniPlay\">\r\n<path d=\"M21.8681 15.2455C21.8681 14.8044 21.4234 14.4872 21.4234 14.4872L8.94233 6.6639C8.0326 6.06051 7.28907 6.50752 7.28907 7.65084L7.28906 22.8416C7.28906 23.9879 8.03259 24.4319 8.94378 23.83L21.4249 16.0038C21.4234 16.0038 21.8681 15.6866 21.8681 15.2455Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol